"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = singleSpaPreact;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var defaultOpts = {
  // required opts
  preact: null,
  rootComponent: null,
  // optional opts
  domElementGetter: null
};

function singleSpaPreact(userOpts) {
  if (_typeof(userOpts) !== "object") {
    throw new Error("single-spa-preact requires a configuration object");
  }

  var opts = _objectSpread(_objectSpread({}, defaultOpts), userOpts);

  if (!opts.preact) {
    throw new Error("single-spa-preact must be passed opts.preact");
  }

  if (!opts.rootComponent) {
    throw new Error("single-spa-preact must be passed opts.rootComponent");
  }

  return {
    bootstrap: bootstrap.bind(null, opts),
    mount: mount.bind(null, opts),
    unmount: unmount.bind(null, opts)
  };
}

function bootstrap(opts) {
  return Promise.resolve();
}

function mount(opts, props) {
  return new Promise(function (resolve, reject) {
    var domElementGetter = chooseDomElementGetter(opts, props);

    if (typeof domElementGetter !== "function") {
      throw new Error("single-spa-preact: the domElementGetter for preact application '".concat(props.appName || props.name, "' is not a function"));
    }

    opts.renderedNode = opts.preact.render(opts.preact.h(opts.rootComponent, props, null), getRootDomEl(domElementGetter, props));
    resolve();
  });
}

function unmount(opts, props) {
  return new Promise(function (resolve, reject) {
    var domElementGetter = chooseDomElementGetter(opts, props);
    opts.preact.render("", // see https://github.com/developit/preact/issues/53
    getRootDomEl(domElementGetter, opts), opts.renderedNode);
    delete opts.renderedNode;
    resolve();
  });
}

function getRootDomEl(domElementGetter, props) {
  var el = domElementGetter(props);

  if (!el) {
    throw new Error("single-spa-preact: domElementGetter function did not return a valid dom element");
  }

  return el;
}

function chooseDomElementGetter(opts, props) {
  if (props.domElement) {
    return function () {
      return props.domElement;
    };
  } else if (props.domElementGetter) {
    return props.domElementGetter;
  } else if (opts.domElementGetter) {
    return opts.domElementGetter;
  } else {
    return defaultDomElementGetter(props);
  }
}

function defaultDomElementGetter(props) {
  var appName = props.appName || props.name;

  if (!appName) {
    throw Error("single-spa-preact was not given an application name as a prop, so it can't make a unique dom element container for the preact application");
  }

  var htmlId = "single-spa-application:".concat(appName);
  return function defaultDomEl() {
    var domElement = document.getElementById(htmlId);

    if (!domElement) {
      domElement = document.createElement("div");
      domElement.id = htmlId;
      document.body.appendChild(domElement);
    }

    return domElement;
  };
}
//# sourceMappingURL=single-spa-preact.js.map